/*!
 *
 *  slider.ts
 *
 */
import Swiper from "swiper";
import { Navigation } from 'swiper/modules';
import 'swiper/css';
class Slider {
    constructor(elem) {
        this.elem = elem;
        this.slider = this.elem.querySelector('.c-slider__main');
        this.next = this.elem.querySelector('.c-slider__next');
        this.prev = this.elem.querySelector('.c-slider__prev');
        this.buildSwiper();
    }
    buildSwiper() {
        new Swiper(this.slider, {
            modules: [Navigation],
            slidesPerView: 3,
            spaceBetween: 0,
            speed: 700,
            loop: true,
            breakpoints: {
                0: {
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                },
                768: {
                    centeredSlides: false,
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                993: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1279: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1579: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1580: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                }
            },
            navigation: {
                nextEl: this.next,
                prevEl: this.prev,
            },
        });
    }
}
export default function (elems) {
    elems.forEach(elem => new Slider(elem));
}
